import { create } from "zustand";

export const useContactStore = create((set) => ({
  search: "",
  setSearchInput: (value) => set(() => ({ search: value })),
}));
